import React from "react";
import "./categoryCard.css";

const CategoryCard = ({ id, category, cardKey, active = false, onSelect }) => {
  return (
    <div
      key={cardKey}
      className={`category-chip-btn ${active ? "active" : ""}`}
      onClick={() => onSelect && onSelect(id)}
    >
      {category}
    </div>
  );
};

export default CategoryCard;
